import '@babel/polyfill';
// import '@webcomponents/webcomponentsjs';
// import 'dom4';
// import 'whatwg-fetch';
// import '@webcomponents/custom-elements/src/native-shim';
// import '@webcomponents/custom-elements/src/custom-elements';



// WEBPACK FOOTER //
// ./scripts/polyfills.js